import { Button, Grid, Link } from '@mui/material'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ConfirmPayDialog, PolicyDialog } from '../helper/Dialogs'
import PageHeader from '../helper/PageHeader'
import { withTranslation } from 'react-i18next';
import { authContext } from '../../context/AuthContext'
import { trainingCost } from '../../constants/global'

import { englishCourseId, spanishCourseId } from '../../constants/global'


const SelectCourse = props => {
    const history = useHistory()

    const userMain = useContext(authContext)
    const username = userMain.user.username

    const [dialogOpen, setDialogOpen] = useState(false)
    const [payDialogOpen, setPayDialogOpen] = useState({ open: false, data: null })
    const [englishCourse, setEnglishCourse] = useState(null)
    const [spanishCourse, setSpanish] = useState(null)
    const [currentCredit, setCurrentCredit] = useState((history.location.state && history.location.state.credit) || null)


    console.log("UserMain", userMain, "Credts", currentCredit)

    const mounted = useRef(true)
    const submitting = useRef(false)


    useEffect(() => {
        async function getDetails() {
            const res = await await axios.all([
                axios.get('/api/course/'+englishCourseId),
                axios.get('/api/course/'+spanishCourseId)
            ])

            let newCurrentCred
            if (!currentCredit) {
                const res2 = await axios.get('/api/user/credit/' + username)
                newCurrentCred = res2.data.user.credit
            }

            if (mounted.current) {
                setEnglishCourse(res[0].data)
                setSpanish(res[1].data)
                if (newCurrentCred) {
                    console.log("Resetting credit amount")
                    setCurrentCredit(newCurrentCred)
                }

            }

        }

        getDetails()
        return () => mounted.current = false
    })

    const onPolicies = () => {
        setDialogOpen(true)
    }


    // check if dvd or zoom, if so go to the code page. Otherwise open dialog for payment
    const onProceed = (data) => {
       
        setPayDialogOpen({ open: true, prevData: data, data: { credit: currentCredit } })

    }

    const onConfirm = async (e) => {
        const { id } = payDialogOpen.prevData.course
    
        e.preventDefault()
        console.log("onConfirm")
        console.log(submitting.current)
        if (!submitting.current) {
            submitting.current = true
            console.log("submitting")
            await axios.post('/api/credit/deduct/user/' + username, {
                credit: trainingCost,
                notes: 'Redeem for Online Training',
                byUsername: username
            },
                {
                    headers: { Authorization: userMain.accessToken }
                })


            await axios.post('/api/userTraining/Online', {
                username,
                courseId: id
            }, {
                headers: { Authorization: userMain.accessToken }
            })

            userMain.updateIsTrainee(true);
            history.push({
                pathname : '/dashboard/user/'+username,
                state :{
                    afterRedeem : true
                }
            });
            submitting.current = false
        }
    }


    return (
        <>
            <PageHeader
                title={props.t('trainingCourses.titleOnline')}
                cancel={history.goBack}
            // title={props.t('trainingCourses.mytraining.title')}
            />
            <PolicyDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
            />
         
            <ConfirmPayDialog
                open={payDialogOpen.open}
                data={payDialogOpen.data}
                onConfirm={onConfirm}
                onClose={() => setPayDialogOpen({ open: false, data: null })}
            />
            <Button variant='contained' color='primary' onClick={onPolicies}>{props.t('trainingCourses.viewPolicies')}</Button>
            <br />
            <br />
            <p>{props.t('trainingCourses.paragraph2')}<Link onClick={onPolicies}>{props.t('trainingCourses.linkPoliciesText')}</Link>{props.t('trainingCourses.paragraph3')}</p>
            <p>{props.t('trainingCourses.pleaseChoose')}</p>
            <Grid container direction="row" justifyContent="space-around" alignItems="center">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(englishCourse)}
                    >
                    {props.t('trainingCourses.english')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(spanishCourse)}
                    >
                    {props.t('trainingCourses.spanish')}
                </Button>
            </Grid>
            <br/>
            <Grid container  justifyContent="space-around"  alignItems="center">
            <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                <ul>
                    <li> {props.t('trainingCourses.onlineDetail1')}</li>
                    <li> {props.t('trainingCourses.onlineDetail2')}</li>
                    <li> {props.t('trainingCourses.onlineDetail3')}</li>
                    <li> {props.t('trainingCourses.onlineDetail4')}</li>
                </ul>
                <p>{props.t('trainingCourses.onlineNote')}</p>
            </Grid>
            </Grid>
        </>
    )
}

export default withTranslation()(SelectCourse)

